var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BottomSheet,{attrs:{"value":_vm.value},on:{"input":function($event){return _setup.emit('input', false)}}},[_c(_setup.OnboardingDialogContent,{attrs:{"flag":_vm.flag},on:{"input":function($event){return _setup.emit('input', false)},"actionClick":function($event){return _setup.actionClick()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }